import Price from 'app/React/Components/Footer/Price'
import React, { useContext, useState } from 'react'
import { usePopper } from 'react-popper'
import { pipe } from 'ts-pipe-compose'
import * as _ from 'lodash/fp'
import InlineTip from 'app/React/Components/misc/InlineTip'
import { sameWidth } from 'app/React/Helpers/OptionHelper'
import IsNotDealerConfigurator from 'app/React/Components/misc/IsNotDealerConfigurator'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function DisplayPrice(props) {
  const {
    order,
    strings
  } = useContext(ConfiguratorContext)

  const fromString = strings.misc?.from ?? 'From'
  const depositLabel = strings.misc?.security_deposit ?? 'Udbetaling'

  const option = props.option

  if (order.paymentType !== 'leasing' || option.use_leasing_price === '0') {
    if (
      typeof props.option.variant_index !== 'undefined' &&
      typeof props.option.min_price !== 'undefined' &&
      props.option.min_price > 0
    ) {
      return (
        <IsNotDealerConfigurator>
          <div>
            <span>{fromString}</span> <Price price={props.option.min_price}/>
          </div>
        </IsNotDealerConfigurator>
      )
    }
    if (typeof props.option.min_price !== 'undefined' && props.option.min_price > 0) {
      return (
        <IsNotDealerConfigurator>
          <span>{fromString}</span>
          <Price price={props.option.min_price}/>
        </IsNotDealerConfigurator>
      )
    }
    if (typeof props.option.price !== 'undefined' && props.option.price > 0) {
      return (
        <IsNotDealerConfigurator>
          <span>+</span>
          <Price price={props.option.price} format='cash'/>
        </IsNotDealerConfigurator>
      )
    }
  } else {
    if (
      typeof props.option.variant_index !== 'undefined' &&
      typeof props.option.security_deposit_leasing !== 'undefined' &&
      typeof props.option.min_price_leasing !== 'undefined' &&
      props.option.min_price_leasing > 0
    ) {
      return (
        <IsNotDealerConfigurator>
          <div>
            <span>{depositLabel}</span> <Price bold price={props.option.security_deposit_leasing} format='cash'/>
          </div>
          <div>
            <span>{fromString}</span> <Price bold price={props.option.min_price_leasing}/>
          </div>
        </IsNotDealerConfigurator>
      )
    }
    if (typeof props.option.min_price_leasing !== 'undefined' && props.option.min_price_leasing > 0) {
      return (
        <IsNotDealerConfigurator>
          <span>{fromString}</span> <Price price={props.option.min_price_leasing}/>
        </IsNotDealerConfigurator>
      )
    }
    if (typeof props.option.price_leasing !== 'undefined' && props.option.price_leasing > 0) {
      return (
        <IsNotDealerConfigurator>
          <span>+</span>
          <Price price={props.option.price_leasing}/>
        </IsNotDealerConfigurator>
      )
    }
  }

  return (
    <IsNotDealerConfigurator>
      <span>+</span>
      <Price price={option.accessory_product_obj.price.raw} format='cash'/>
    </IsNotDealerConfigurator>
  )
}

export function AccessoryOption(props) {
  const {
    cartItems,
    order,
    setCartItems,
    setInteriorImage
  } = useContext(ConfiguratorContext)

  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const [arrowElement, setArrowElement] = useState(null)

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'left',
    strategy: 'fixed',
    modifiers: [
      {
        name: 'preventOverflow',
        options: { padding: 16 }
      },
      {
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      },
      {
        name: 'arrow',
        options: { element: arrowElement }
      },
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['bottom', 'top'],
          padding: { bottom: 80 }
        }
      },
      sameWidth
    ]
  })

  const htmlId = 'option' + props.settingid + '_' + props.option.id + (props.htmlIdPostfix ? '_' + props.htmlIdPostfix : '')

  const option = props.option
  const inputName = 'option' + props.settingid
  const inputValue = option.id

  const disabled = pipe(
    option.option_selectable_rules_option,
    _.castArray,
    _.filter(Boolean),
    _.all((rule) =>
      pipe(
        order.configuration,
        _.omit(['variants', 'engine_transmission']),
        Object.values,
        _.some(_.propEq('id', rule)),
        (value) => {
          return option.option_selectable_rules_is_selected === '0' ? !value : value
        },
        Boolean
      )
    ),
    _.negate(Boolean)
  )

  const hidden = option.hide_on === order.paymentType || option.hide_on === 'all'
  const isInCart = Boolean(cartItems.find((item) => item.id === Number(props.option.accessory_product)))

  if (hidden) {
    return hidden
  }

  return (
    <>
      <input
        id={htmlId}
        type='checkbox'
        name={inputName}
        value={inputValue}
        checked={isInCart}
        data-checked={isInCart}
        onChange={(e) => {
          if (isInCart) {
            setCartItems(cartItems.filter((item) => item.id !== Number(props.option.accessory_product)))
            setInteriorImage(null)
          } else {
            setCartItems([...cartItems, props.option.accessory_product_obj])
            setInteriorImage(props.option)
          }

          // props.setChecked(props.option.id)
        }}
        disabled={disabled}
      />
      <label
        ref={setReferenceElement}
        htmlFor={htmlId}
        className='option'
        layout={props.layout}
        data-disabled={disabled}
      >
        {typeof option.image_url === 'string' && option.image_url.length >= 0 ? (
          <img className='image' src={option.image_url} alt=''/>
        ) : null}
        <div>{option.title?.length > 0 ? option.title : option.name}</div>
        <div className='description'>
          {option.description_override ? (
            <span dangerouslySetInnerHTML={{ __html: option.description_override }}/>
          ) : (
            <>
              <DisplayPrice {...props} />
              {option.description_title?.length > 0 && option.description?.length > 0 ? (
                <InlineTip button='Ok' label={option.description_title} content={option.description}/>
              ) : null}
              {option.description_title?.length > 0 && !option.description?.length > 0 ? (
                <span dangerouslySetInnerHTML={{ __html: option.description_title }}/>
              ) : null}
            </>
          )}
        </div>
      </label>
      {disabled && option.tooltip_unselectable ? (
        <div className='tooltip2' ref={setPopperElement} style={styles.popper} {...attributes.popper}>
          <div dangerouslySetInnerHTML={{ __html: option.tooltip_unselectable }}/>
          <div className='arrow' ref={setArrowElement} style={styles.arrow}/>
        </div>
      ) : null}
    </>
  )
}
